<script setup lang="ts">
import { computed } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'TutorKanbanHeader',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'tutor-kanban',
    text: 'Tutor Kanban',
    to: AppRoute.TutorKanbanOnboarding,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
